<template>

  <div>

    <transition
      name="slide-left"
      mode="out-in">

      <search-model
        v-if="!model"
        @leave="$emit('leave')"
        />

      <info-model
        v-else-if="!isMtsFlow"
        :model="model"
        @leave="$emit('leave')"
        @next="nextPage"
        @badmodel="changeModel({ btag: model.btag })" />

    </transition>

  </div>

</template>

<script>
import { mapState, mapActions } from 'vuex';

import SearchModel from './ScreenOne/SearchModel';
import InfoModel from './ScreenOne/InfoModel';

export default {
  components: {
    SearchModel,
    InfoModel,
  },
  computed: {
    ...mapState('buyphones', ['model']),
    ...mapState('user', ['user']),
    isMtsFlow() {
      return this.user.flowType === 'mts';
    }
  },
  methods: {
    ...mapActions('buyphones', ['changeModel', 'getQuestions']),

    nextPage(data) {
      this.getQuestions(this.model.btag);
      this.$emit('changeScreen', {type: 'next', id: 0})
    }
  }
}
</script>

<style lang="css">
</style>
